import type { Subscription } from '../../../../../types';

import * as styles from './index.css';
import EntitlementRow from './components/entitlement-row';
import Typography from '@blueshift-ui/theme/dist/components/typography';
import getSubscriptonPrice from '../../../../../helpers/data/get-subscription-price';
import useTranslation from '@blueshift-ui/i18n/dist/hooks/use-translation';

interface EntitlementComparisonTableProps {
  subscription: Subscription;
}

function EntitlementComparisonTable({ subscription }: EntitlementComparisonTableProps) {
  const { translate } = useTranslation('cancel_membership_page.entitlements');

  const { currency, price } = getSubscriptonPrice(subscription);

  return (
    <div className={styles.comparisonTable}>
      <header className={styles.header}>
        <div className={styles.bufferCell} />
        <div className={styles.headerCell}>
          <Typography>{translate('canceled_plan_label')}</Typography>
          <Typography>
            {translate('canceled_plan_hours', {
              number_of_hours: subscription.entitlements.find(
                ({ type }) => type === 'tutoring_hours'
              )?.configuration.number_of_hours,
            })}
          </Typography>
          <Typography>
            {`${Intl.NumberFormat(undefined, {
              style: 'currency',
              currency: currency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(price)}/${subscription.billing_frequency_unit}`}
          </Typography>
        </div>
        <div className={styles.headerCell}>
          <Typography>{translate('new_plan_label')}</Typography>
          <Typography>{translate('new_plan_name')}</Typography>
          <Typography>{translate('new_plan_price')}</Typography>
        </div>
      </header>
      <EntitlementRow hasFreePlan={false} hasPaidPlan={true} label={translate('one_on_one')} />
      <EntitlementRow
        hasFreePlan={false}
        hasPaidPlan={true}
        label={translate('special_tutoring_rate')}
      />
      <EntitlementRow
        hasFreePlan={false}
        hasPaidPlan={true}
        label={translate('access_to_roster')}
      />
      <EntitlementRow
        hasFreePlan={false}
        hasPaidPlan={true}
        label={translate('instant_tutoring')}
      />
      <EntitlementRow hasFreePlan={false} hasPaidPlan={true} label={translate('session_notes')} />
      <EntitlementRow hasFreePlan={false} hasPaidPlan={true} label={translate('live_classes')} />
      <EntitlementRow hasFreePlan={true} hasPaidPlan={true} label={translate('ai_tutor')} />
      <EntitlementRow
        hasFreePlan={true}
        hasPaidPlan={true}
        label={translate('on_demand_content')}
      />
      <EntitlementRow hasFreePlan={true} hasPaidPlan={true} label={translate('assessments')} />
    </div>
  );
}

export default EntitlementComparisonTable;
